class LoadMoreButton extends HTMLElement {
  constructor() {
    super();

    this.grid = document.querySelector('.load-more-grid');
    this.button = this.querySelector('.load-more-button');
    this.wrapper = this.closest('.load-more-wrapper');

    if (!this.grid || !this.button || !this.wrapper) return;

    this.buttonText = this.querySelector('.load-more-button__text');
    this.countCurrent = this.querySelector('.load-more-count__current');
    this.countTotal = this.querySelector('.load-more-count__total');
    this.progressFill = this.querySelector('.load-more-progress__fill');

    this.totalProducts = Number(this.button.dataset.totalProducts);
    this.nextUrl = this.button.dataset.nextUrl;
    this.isLoading = false;

    this.button.addEventListener('click', (event) => {
      // Allow links to open normally in a new tab.
      if (
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        event.button > 0
      ) {
        return;
      }

      event.preventDefault();

      if (!this.isLoading) this.load();
    });

    this.updateCount();

    if (!this.nextUrl) this.hide();
  }

  updateCount() {
   
  const currentCount = this.grid.querySelectorAll(
  ':scope > li:not(.promotion-card)'
).length;

    if (this.countCurrent) {
      this.countCurrent.textContent = currentCount;
    }

    if (this.countTotal) {
      this.countTotal.textContent = this.totalProducts;
    }

    if (this.progressFill && this.totalProducts > 0) {
      this.progressFill.style.width =
        `${Math.min(100, (currentCount / this.totalProducts) * 100)}%`;
    }
  }

  hide() {
    this.wrapper.classList.add('hidden');
  }

  async load() {
    if (this.isLoading) return;
    if (!this.nextUrl) return this.hide();

    const requestedUrl = this.nextUrl;

    this.isLoading = true;
    this.button.disabled = true;
    this.button.setAttribute('aria-disabled', 'true');
    this.grid.setAttribute('aria-busy', 'true');

    if (this.buttonText) {
      this.buttonText.textContent = 'Loading...';
    }

    try {
      const response = await fetch(requestedUrl);

      if (!response.ok) {
        throw new Error(`Page request failed: ${response.status}`);
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = doc.querySelector('#product-grid');

      if (!nextGrid) {
        throw new Error('Product grid missing from the next page.');
      }

      const items = Array.from(nextGrid.children).filter(
        (item) => item.tagName === 'LI'
      );

      if (!items.length) {
        throw new Error('No products found on the next page.');
      }

      items.forEach((item) => this.grid.append(item));

      const newButton = doc.querySelector('.load-more-button');
      this.nextUrl = newButton?.dataset.nextUrl || null;

      if (this.nextUrl) {
        this.button.dataset.nextUrl = this.nextUrl;

        // Keep the real link pointing to the next unloaded page.
        if (this.button.tagName === 'A') {
          this.button.setAttribute('href', this.nextUrl);
        }
      } else {
        delete this.button.dataset.nextUrl;
        this.hide();
      }

      this.updateCount();
    } catch (error) {
      console.error('Load more error:', error);

      // Fall back to normal page navigation if loading fails.
      window.location.assign(requestedUrl);
    } finally {
      this.isLoading = false;
      this.button.disabled = false;
      this.button.removeAttribute('aria-disabled');
      this.grid.removeAttribute('aria-busy');

      if (this.buttonText) {
        this.buttonText.textContent = 'Load More';
      }
    }
  }
}

if (!customElements.get('load-more-button')) {
  customElements.define('load-more-button', LoadMoreButton);
}